// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as GemAlertExtended } from '../../../assets/icons/extended/entities/gem-alert.svg?react';
import { createIcons } from '../../Icon';
const GemAlertIcon = /* @__PURE__ */ createIcons('GemAlert', {
    extended: GemAlertExtended
});
GemAlertIcon.supportedTypes = ['extended'];
GemAlertIcon.category = 'entities';
export default GemAlertIcon;
